module.exports = __webpack_public_path__ + "assets/img/Group2.0622a843.png";